import React, { useContext, useState } from 'react';
import { Button, Col, Dropdown, MenuProps, notification, Row, Tag } from 'antd';
import axiosInstance from '../../../../../../../axios_instance';
import { IsAdminContext, NumberOfStrengthPassionsContext, UserStrengthPassionsDataContext } from '../../../../../../../context';
import { useParams } from 'react-router-dom';
import DeleteModal from '../../../../../modal/delete';
import styles from "./styles.module.scss";
import EditStrengthPassion from '../edit-strength-passion';

interface StrengthPassionProps {
  strength_passion_id: number;
  name: string;
  description: string;
  type: string;
  show_in_resume: boolean;
}

const StrengthPassionsDetails: React.FC<StrengthPassionProps> = ({
  strength_passion_id,
  name,
  description,
  type,
  show_in_resume
}: StrengthPassionProps): JSX.Element => {
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const { setUserStrengthPassionsData } = useContext(UserStrengthPassionsDataContext);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const { setNumberOfStrengthPassions } = useContext(NumberOfStrengthPassionsContext);

  const openNotification = (notificationType: 'success' | 'info' | 'warning' | 'error', title: string) => {
    notification[notificationType]({
      message: notificationType === 'info' ? `Deleting StrengthPassion ${title}` : (notificationType === 'success' ? `Deleted StrengthPassion ${title} Successfully` : (notificationType === 'error' ? `An error occurred while deleting achievement ${title}` : "")),
    });
  };

  const handleDelete = () => {
    openNotification('info', name);
    let reqBody = {};
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/strength_passions';
      reqBody = { profile_id: employeeId, strength_passion_id, status: 3 };
    } else {
      url = '/api/v1/profile/strength_passions';
      reqBody = { strength_passion_id, status: 3 };
    }
    axiosInstance.post(url, reqBody).then((response) => {
      let userStrengthPassions: Array<any> = [];
      if (response.data.strength_passions.length !== 0) {
        userStrengthPassions = response.data.strength_passions.filter(
          (StrengthPassion: any) =>
            StrengthPassion['status']['id'] === 1
        );
        // const orderedStrengthPassions = response.data.strengthPassions.map((achievementId: number) =>
        //   userStrengthPassions.find((userStrengthPassion: any) => userStrengthPassion.achievement_id === achievementId)
        // ).filter((item: any) => item !== undefined);
        setUserStrengthPassionsData(userStrengthPassions);
      } else {
        setUserStrengthPassionsData(response.data.strength_passions);
      }
      setNumberOfStrengthPassions(userStrengthPassions.length);
      openNotification('success', name);
    }).catch((error) => {
      console.log(error);
      openNotification('error', name);
    });
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <div
          onClick={(e) => {
            setIsEditable(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Edit</p>
        </div>
      ),
      key: '0',
    },
    {
      label: (
        <div
          onClick={() => {
            setIsDeleteModalOpen(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Delete</p>
        </div>
      ),
      key: '1',
    },
  ];

  return (
    <div>
      {isDeleteModalOpen ? (
        <DeleteModal
          {...{
            isModalOpen: isDeleteModalOpen,
            setIsModalOpen: setIsDeleteModalOpen,
            handleDelete: handleDelete,
          }}
        />
      ) : (
        <></>
      )}
      {isEditable ? (
        <EditStrengthPassion
          {...{
            strength_passion_id,
            name,
            type,
            description,
            setIsEditable,
            show_in_resume
          }}
        />
      ) : (
        <Row key={strength_passion_id} className={styles.row} gutter={{ xs: 8, sm: 16 }}>
          <div style={{ display: "flex", alignItems: "center", position: "absolute", bottom: "5px", right: "5px" }}>
            {
              show_in_resume ? (
                <Tag color="success">
                  Show in resume: Yes
                </Tag>
              ) : (
                <Tag color="error">
                  Show in resume: No
                </Tag>
              )
            }
          </div>
          <Col span={12}>
            <Row>
              <h3 className={styles['StrengthPassion-text']}>
                <b>{name}</b>
              </h3>
            </Row>
            <Row>
              <p>
                <span>Type : </span>
                <span>{Number(type) === 1 ? "Strength" : "Passion"}</span>
              </p>
            </Row>
          </Col>
          <Col span={11}>
            {
              description && (
                <Row>
                  <Col span={12}>
                    <p>
                      <span>Description : </span>
                      <span>{description}</span>
                    </p>
                  </Col>
                </Row>
              )
            }
          </Col>
          <Dropdown menu={{ items }} trigger={['click']} placement="bottomLeft">
            <Button
              type="text"
              style={{
                position: 'absolute',
                right: '5px',
                border: 'hidden',
                textDecoration: 'blue',
                top: "10px"
              }}

            >
              <img
                src="/more_vert.png"
                style={{
                  marginLeft: 'auto',
                  marginRight: '0px',
                  height: '15px',
                  width: '5px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              />
            </Button>
          </Dropdown>
        </Row>
      )}
    </div>
  );
};

export default StrengthPassionsDetails
